$('.feed-slider').owlCarousel({
    loop: true,
    margin: 10,
    nav: true,
    dots: true,
    navText: ["<img src='./images/Group-117.png' >", "<img src='./images/Group-116.png' >"],
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 1
        },
        1000: {
            items: 1
        }
    ,
    1200: {
        items: 2
    }
}
});

$('.sliderOntainerInner').owlCarousel({
    loop: true,
    margin: 10,
    nav: true,
    navText: ["<img src='./images/Group-117.png' >", "<img src='./images/Group-116.png' >"],
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 1
        },
        1000: {
            items: 1
        }
    }
})
AOS.init();